import businessforce from "@/assets/logos/businessforce.svg";
import kommunikationslotsen from "@/assets/partner/kommunikationslotsen.jpg.asset.json";
import teamsysplus from "@/assets/partner/teamsysplus.png.asset.json";
import brainHr from "@/assets/partner/brain-hr.png.asset.json";
import zortify from "@/assets/partner/zortify-pink.svg.asset.json";
import schaffensgeist from "@/assets/partner/schaffensgeist-marke.png.asset.json";
import witos from "@/assets/partner/witos.png.asset.json";
import rathgeber from "@/assets/partner/rathgeber-consulting.jpg.asset.json";

export interface Partner {
  name: string;
  branche: string;
  url?: string;
  logo?: string;
  /** Logo is white – needs dark card background */
  dark?: boolean;
  /** Tailwind classes for the logo box; defaults to the standard tile logo size */
  logoClass?: string;
}

export const partners: Partner[] = [
  { name: "Businessforce", branche: "Strategieberatung", url: "https://businessforce.eu/", logo: businessforce },
  { name: "Kommunikationslotsen", branche: "Home of Facilitation", url: "https://kommunikationslotsen.de/", logo: kommunikationslotsen.url },
  {
    name: "Schaffensgeist",
    branche: "Beratung für souveräne Kommunikation",
    url: "https://www.schaffensgeist.com/",
    logo: schaffensgeist.url,
    // Wide horizontal wordmark – needs a wider box so the thin "GEIST" stays readable
    logoClass: "h-14 w-auto max-w-[150px] shrink-0 object-contain",
  },
  { name: "teamsysplus Akademie", branche: "Ausbildungsinstitut", url: "https://www.teamsysplus-akademie.de/", logo: teamsysplus.url },
  { name: "Brain-HR", branche: "Weiterentwicklung durch Wissenschaft", url: "https://brain-hr.de/", logo: brainHr.url },
  { name: "Zortify", branche: "KI-gestütztes Talent Assessment seit 2018", url: "https://zortify.com/de/", logo: zortify.url },
  { name: "Witos Berlin", branche: "Team- & Organisationsentwicklung, Coaching und Training", url: "http://www.witos-berlin.de/", logo: witos.url },
  { name: "Rathgeber Consulting", branche: "Marketingberatung", url: "https://rathgeber-consulting.com", logo: rathgeber.url },
  { name: "Marion Michels", branche: "Ausbildungsinstitut", url: "https://www.m-sight.de/" },
];
